module.exports = __webpack_public_path__ + "img/logo.62008aba.png";